/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { GetEncounterErrorResponse, GetEncounterResponse } from './api.schemas';

import { api } from '../util/http';

export const getEncounters = (encounterId: number, signal?: AbortSignal) => {
  return api<GetEncounterResponse>({
    url: `/api/encounters/${encounterId}`,
    method: 'GET',
    signal,
  });
};

export const getGetEncountersQueryKey = (encounterId?: number) => {
  return [`/api/encounters/${encounterId}`] as const;
};

export const getGetEncountersQueryOptions = <
  TData = Awaited<ReturnType<typeof getEncounters>>,
  TError = GetEncounterErrorResponse,
>(
  encounterId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEncounters>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEncountersQueryKey(encounterId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEncounters>>> = ({ signal }) =>
    getEncounters(encounterId, signal);

  return { queryKey, queryFn, enabled: !!encounterId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEncounters>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetEncountersQueryResult = NonNullable<Awaited<ReturnType<typeof getEncounters>>>;
export type GetEncountersQueryError = GetEncounterErrorResponse;

export function useGetEncounters<
  TData = Awaited<ReturnType<typeof getEncounters>>,
  TError = GetEncounterErrorResponse,
>(
  encounterId: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEncounters>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEncounters>>,
          TError,
          Awaited<ReturnType<typeof getEncounters>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEncounters<
  TData = Awaited<ReturnType<typeof getEncounters>>,
  TError = GetEncounterErrorResponse,
>(
  encounterId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEncounters>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEncounters>>,
          TError,
          Awaited<ReturnType<typeof getEncounters>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEncounters<
  TData = Awaited<ReturnType<typeof getEncounters>>,
  TError = GetEncounterErrorResponse,
>(
  encounterId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEncounters>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetEncounters<
  TData = Awaited<ReturnType<typeof getEncounters>>,
  TError = GetEncounterErrorResponse,
>(
  encounterId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEncounters>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetEncountersQueryOptions(encounterId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
